const RANK_TYPES = {
  GOLD: 'Gold',
  SILVER: 'Silver',
  BRONZE: 'Bronze',
} as const;

const POINTS_RANKING = [
  {
    rank: RANK_TYPES.GOLD,
    points: 1000,
  },
  {
    rank: RANK_TYPES.SILVER,
    points: 500,
  },
  {
    rank: RANK_TYPES.BRONZE,
    points: 100,
  },
];

export const getUserPointsRanking = (totalPoints: number) => {
  for (const { rank, points } of POINTS_RANKING) {
    if (totalPoints >= points) {
      return rank;
    }
  }

  // Default to Bronze if points are less than the lowest threshold
  return RANK_TYPES.BRONZE;
};
